import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";

// Componentes react-bootstrap
import { Container, Button, Modal, Form } from "react-bootstrap";

import getDatos from "../../services/getDatos";
import setDatos from "../../services/setDatos";
import guardarUbicacion from "../../services/guardarUbicacion";
import Load from "./Load";
import Alertas from "../common/Alertas";

const Rating = ({ idRegistro, route, numCalificacion, reRender, origen }) => {
  const [rate, setRate] = useState(numCalificacion);
  const [rateOriginal, setRateOriginal] = useState(numCalificacion);
  const [loadVisible, setLoadVisible] = useState(false);

  useEffect(() => {
    setRate(numCalificacion);
  }, [reRender]);

  // Estado modal
  const [show, setShow] = useState(false);

  // Estado calificacion
  const [elementsFormCalificacion, setElementsFormCalificacion] = useState({
    calificacionNum: 0,
    nombre: "",
    correo: "",
    idUso: "",
    descripcion: "",
    idRegistro,
  });

  const [uso, setUso] = useState();

  const [calificacion] = useState([...Array(5)]);

  // Cerrar modal
  const handleClose = (guardado) => {
    setShow(false);
    if (guardado) {
      setRateOriginal(rate);
    } else {
      setRate(rateOriginal);
    }
  };

  // Abrir modal
  const handleShow = () => setShow(true);

  // hadleChange set state calificacion

  const handleChange = (e, name) => {
    //set de valores de los elementos html introducidos

    let evento = e ? e : "";
    if (evento?.target) {
      setElementsFormCalificacion({
        ...elementsFormCalificacion,
        [e.target.name]: e.target.checked ? e.target.checked : e.target.value,
      });
    } else {
      setElementsFormCalificacion({
        ...elementsFormCalificacion,
        [name]: e ? e.value : "-1",
      });
    }
  };

  async function guardarCalificacion() {
    const { nombre, correo, calificacionNum, descripcion, idUso } =
      elementsFormCalificacion;

    const isValidEmail =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!nombre || !correo || !descripcion || !idUso || idUso === "0") {
      Alertas({
        title: "",
        html: "<span>Los campos marcados con * son obligatorios.</span>",
        icono: "warning",
      });

      return;
    }

    if (!isValidEmail.test(correo)) {
      Alertas({
        title: "",
        html: "<span>Ingresa un correo valido.</span>",
        icono: "warning",
      });

      return;
    }

    if (!calificacionNum) {
      Alertas({
        title: "",
        html: "<span>Seleccione una estrella para calificar.</span>",
        icono: "warning",
      });
      return;
    }

    try {
      setLoadVisible(true);
      let resultCalificacion = await setDatos(route, elementsFormCalificacion);
      await guardarUbicacion("0", "0", "0", resultCalificacion.id);
      let datosCorreo = elementsFormCalificacion;
      datosCorreo["origen"] = origen;

      await setDatos("geomed/calificacion/correo", {
        ...datosCorreo,
        nombreUso: uso.find(
          (usoData) =>
            Number(usoData.id_uso) === Number(elementsFormCalificacion.idUso)
        ).nombre,
      });
      Alertas({
        title: "",
        html: "<span>Registro guardado exitosamente.</span>",
        icono: "success",
      });
      await guardarUbicacion(origen, "2", elementsFormCalificacion.idRegistro);
      setLoadVisible(false);
    } catch (error) {
      Alertas({
        title: "",
        html: "<span>Error al calificar.</span>",
        icono: "warning",
      });
      setLoadVisible(false);
    }
    handleClose(true);
  }

  useEffect(() => {
    async function aux() {
      const data = await getDatos("atributos/combos");
      setUso(data?.resultUso);
    }
    aux();
  }, []);

  return (
    <div>
      <Load visible={loadVisible} />
      {calificacion.map((item, index) => {
        const givenRating = index + 1;
        return (
          <label key={`lblCalificacionNum${index}`}>
            <input
              // key={`calificacionNum${index}`}
              className="radio-rating"
              type="radio"
              value={givenRating}
              name={"calificacionNum"}
              onClick={(e) => {
                setRate(givenRating);
                handleShow();
                setElementsFormCalificacion({
                  ...elementsFormCalificacion,
                  [e.target.name]: givenRating,
                });
              }}
            />
            <div className="cursor-pointer">
              <FaStar
                color={
                  Number(rate) >= givenRating
                    ? "rgb(255,170,4)"
                    : "rgb(192,192,192)"
                }
              />
            </div>
          </label>
        );
      })}

      <Modal show={show} onHide={handleClose} size="md" id="modalCalificacion">
        <Modal.Header closeButton>
          <Modal.Title>Califícanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="pb-2">
            <div className="calificacion-stars">
              <div className="cursor-pointer">
                {calificacion.map((item, index) => {
                  const givenRating = index + 1;
                  return (
                    <label key={index}>
                      <input
                        className="radio-rating"
                        type="radio"
                        value={givenRating}
                        name={"calificacionNum"}
                        onClick={(e) => {
                          setRate(givenRating);
                          setElementsFormCalificacion({
                            ...elementsFormCalificacion,
                            [e.target.name]: givenRating,
                          });
                        }}
                      />
                      <div className="cursor-pointer">
                        <FaStar
                          className="m-2"
                          color={
                            Number(rate) >= givenRating
                              ? "rgb(255,170,4)"
                              : "rgb(192,192,192)"
                          }
                        />
                      </div>
                    </label>
                  );
                })}
              </div>
              <p className="rate-range-calificacion">
                {rate}/{calificacion.length}
              </p>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="label-forms-calificacion">
                Nombre <strong>*</strong>
              </Form.Label>
              <Form.Control
                type="text"
                className="inputs-forms-calificacion focus-calificacion"
                name={"nombre"}
                onChange={(e) => {
                  handleChange(e, "nombre");
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-calificacion">
                Correo <strong>*</strong>
              </Form.Label>
              <Form.Control
                type="text"
                className="inputs-forms-calificacion focus-calificacion"
                name={"correo"}
                onChange={(e) => {
                  handleChange(e, "correo");
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="label-forms-calificacion">
                Cuentános, ¿cómo estás usando los datos? <strong>*</strong>
              </Form.Label>
              <Form.Select
                className="inputs-forms-calificacion focus-calificacion"
                name={"idUso"}
                onChange={(e) => {
                  handleChange(e, "idUso");
                }}
              >
                <option value={"0"} selected>
                  Seleccione.....
                </option>
                {uso
                  ? uso?.map((e, i) => {
                      return (
                        <option key={`usoOption${i}`} value={e?.id_uso}>
                          {e?.nombre}
                        </option>
                      );
                    })
                  : ""}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="label-forms-calificacion">
                Descripción <strong>*</strong>
              </Form.Label>
              <Form.Control
                as="textarea"
                className="inputs-forms-calificacion focus-calificacion textarea-form-calificacion"
                name={"descripcion"}
                onChange={(e) => {
                  handleChange(e, "descripcion");
                }}
              />
            </Form.Group>

            <div className="container-accion-calificacion mt-3">
              <Button
                className="btn-geomedellin btn-register-calificacion btn-accion"
                onClick={() => {
                  guardarCalificacion();
                }}
              >
                Enviar
              </Button>
            </div>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Rating;
